import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../../index.css";
import "./PortraitSelectionPageStyles.css"
import MediaCard from "../../components/MediaCard/MediaCard";
import CoverTitle from "../../components/CoverTitle/CoverTitle";
import MediaService from "../../services/mediaService";

function PortaitSelectionPage() {
  const navigate = useNavigate();
  const [mediaUrls, setMediaUrls] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchMedia() {
      try {
        const response = await MediaService.getGallery('assets', 'video', "portrait-select-page")
        setMediaUrls(response.filter(file => file.id !== "" && file.size > 0).sort((a, b) => a.id.localeCompare(b.id)));
      } catch (error) {
        console.error("Error fetching R2 assets:", error);
      } finally {
        setLoading(false);
      }
    }
    fetchMedia();
  }, []);

  const handleCategoryClick = (categoryName) => {
    console.log(`Navigating to /portrait/${categoryName}`);
    navigate(`/portrait/${categoryName}`);
  };
  
  if (loading) {
    return (
      <div className="portrait-page-container" role="status" aria-live="polite">
        <p>Loading portraits...</p>
      </div>
    );
  }

  if (mediaUrls.length < 2) {
    return (
      <div className="portrait-page-container">
        <p>Portrait media is currently unavailable.</p>
      </div>
    );
  }

  return (
    <div className="portrait-page-container">
        <CoverTitle clr="clr-dark-red" title="Commercial" class_Name="portrait-page-title">Portraits</CoverTitle>
              
      {/* Card 1: Image Background */}
     
      <div className="card-gallery-container">   
        <MediaCard
        // mediaSrc="/photo-assets/portraits/portrait-photo-reel-comp.mp4"
        mediaSrc={mediaUrls[0].src}
        mediaType="video"
        title="Photo"
        onClick={() => handleCategoryClick('photo')}
        class_Name="portrait-media-card"
      />

      {/* Card 2: Video Background */}
      <MediaCard
        // mediaSrc="/video-assets/portraits/models/mari-video-portrait-comp.mp4"
        mediaSrc={mediaUrls[1].src}
        mediaType="video"
        title="Video"
        class_Name="portrait-media-card"
        onClick={() => handleCategoryClick('video')}
      />
      </div>
   </div>
  );
}

export default PortaitSelectionPage;
